import { render, staticRenderFns } from "./Cliente.vue?vue&type=template&id=f806959e&scoped=true"
import script from "./Cliente.vue?vue&type=script&lang=js"
export * from "./Cliente.vue?vue&type=script&lang=js"
import style0 from "./Cliente.vue?vue&type=style&index=0&id=f806959e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f806959e",
  null
  
)

export default component.exports